<template>
  <div>

    <!-- Navigation Component -->
    <navigation />

    <Toast position="top-right" />

    <DataTable ref="dt" :value="this.editLogInfo" editMode="cell" class="editable-cells-table bulk-update" :scrollable="true">

      <Column field="liability_id" header="Liability ID" headerStyle="width: 170px" :disabled="true">
      </Column> 

      <Column field="username" header="User Name" headerStyle="width: 170px" :disabled="true">
      </Column> 

      <Column field="updatedAt" header="Updated At" headerStyle="width: 200px" :disabled="true">
      </Column>

      <Column field="type" header="Type" headerStyle="width: 200px" :disabled="true">
      </Column>

      <Column field="field" header="Field" headerStyle="width: 200px" :disabled="true">
      </Column>

      <Column field="old_value" header="Old Value" headerStyle="width: 200px" :disabled="true">
      </Column>

      <Column field="new_value" header="New Value" headerStyle="width: 200px" :disabled="true">
      </Column>
    </DataTable>
  </div>
</template>

<script>
  import navigation from "../../components/helperComponents/menu";
  import DataTable from "primevue/datatable";
  import Column from "primevue/column";
  import InputText from "primevue/inputtext";
  import Toolbar from "primevue/toolbar";
  import Dropdown from "primevue/dropdown";
  import Button from "primevue/button";
  import Textarea from 'primevue/textarea';
  import Tooltip from 'primevue/tooltip';
  import Toast from 'primevue/toast';

  export default {
    name: 'EditLog',
    components: {
      Textarea,
      DataTable,
      Column,
      navigation,
      InputText,
      Toolbar,
      Dropdown,
      Button,
      Toast
    },
    directives: {
      'tooltip': Tooltip
    },
    props: {
      editLogInfo: Array
    },
    data() {
      return {
        filters: {}
      }
    }
  };
</script>

<style>
.p-datatable-scrollable-view .p-datatable-scrollable-header-box {
  padding-right: 0px !important; /* Override inline style */
}
</style>